var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHubspot = function SvgHubspot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 43,
    fill: "none",
    viewBox: "0 0 39 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2411_171060)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A59",
    stroke: "#fff",
    strokeWidth: 1.345,
    d: "m21.035 3.046 12.161 7.039a2.81 2.81 0 0 1 1.401 2.433v14.078a2.81 2.81 0 0 1-1.4 2.434l-12.162 7.038a2.8 2.8 0 0 1-2.8 0L6.074 29.03a2.81 2.81 0 0 1-1.401-2.434V12.518c0-1.004.534-1.932 1.4-2.433l12.162-7.04a2.8 2.8 0 0 1 2.8 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.965 17.708v-2.01a1.55 1.55 0 0 0 .908-1.394v-.046a1.56 1.56 0 0 0-.466-1.096 1.57 1.57 0 0 0-1.108-.45h-.047a1.57 1.57 0 0 0-1.108.45c-.295.29-.463.683-.467 1.096v.046a1.54 1.54 0 0 0 .909 1.394v2.01a4.5 4.5 0 0 0-2.124.922l-5.622-4.298q.06-.213.063-.435c0-.468-.188-.918-.52-1.249a1.78 1.78 0 0 0-2.513 0c-.333.331-.52.78-.52 1.249a1.75 1.75 0 0 0 .89 1.51 1.78 1.78 0 0 0 1.761-.002l5.53 4.22a4.33 4.33 0 0 0 .069 4.956l-1.684 1.655a1.44 1.44 0 0 0-1.577.567 1.422 1.422 0 0 0 .764 2.17 1.44 1.44 0 0 0 1.589-.535 1.42 1.42 0 0 0 .267-.836 1.4 1.4 0 0 0-.068-.41l1.664-1.632a4.52 4.52 0 0 0 2.72.905c2.48 0 4.49-1.973 4.49-4.405 0-2.203-1.65-4.023-3.802-4.35zm-.69 6.61a2.3 2.3 0 0 1-1.256-.396 2.247 2.247 0 0 1-.313-3.473 2.28 2.28 0 0 1 2.473-.477 2.27 2.27 0 0 1 1.016.833c.248.37.38.807.38 1.252a2.26 2.26 0 0 1-.68 1.604 2.3 2.3 0 0 1-1.62.656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2411_171060",
    width: 38.397,
    height: 42.247,
    x: 0.436,
    y: 0.215,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.782
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.782
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_171060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2411_171060",
    result: "shape"
  })))));
};
export default SvgHubspot;